import React from 'react';

export default (props)=> {
  return <a href='' onClick={(e)=> {
    e.preventDefault()
    props.onClick()
  }}><i className="icon fs-5 bi-pencil px-1" /></a>
}
